<template>
  <a-config-provider>
    <template #renderEmpty>
      <div class="text-center">{{ noDataPlaceholder }}</div>
    </template>
    <a-select
      :value="value"
      :style="{ width }"
      allow-clear
      show-search
      :class="class"
      :mode="modeType"
      :placeholder="placeholder"
      :disabled="disabled"
      option-filter-prop="title"
      @change="onChange"
      @clear="onClear"
      :maxTagTextLength="maxTagTextLength"
      :maxTagCount="maxTagCount"
    >
    <template #maxTagPlaceholder="omittedValues">
      <span style="color: red" :title="titleValue">+ {{ omittedValues.length }} ...</span>
    </template>
      <a-select-option
        v-for="item in options"
        :key="item.id"
        :value="item.id"
        :title="item.name"
        :disabled="item.disabled"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
  </a-config-provider>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted, toRaw, PropType, watch } from "vue";
import { CompanyTypeService } from "@/views/cooperation/company-type/company-type.service";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
/**
 * 往来单位类型选择器
 *
 * 使用方式:
 * <company-type-select v-model:value="formRef.companyTypeId"></company-type-select>
 */
export default defineComponent({
  name: "CompanyTypeSelect",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      type: Array,
      default: () => [],
    },
    maxCount: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noDataPlaceholder: {
      type: String,
      default: "请先前往「基础信息-往来单位类别管理」设置具体类别",
    },
    class: {
      type: String,
      default: "append-to-parent",
    },
    modeType: {
      type: String,
      default: "multiple",
    },
    typeAttributionList: {
      type: Array,
      default: () => null,
    },
    typeAttribution: {
      type: Array,
      default: () => null,
    },
    maxTagCount: {
      type: Number,
      default: 3,
    },
    maxTagTextLength: {
      type: Number,
      default: 4,
    },
  },
  emits: ["update:value","change","update:typeAttributionList"],
  setup(props, { attrs, slots, emit }) {
    const { data, run, loading } = CompanyTypeService.useSimpleListApi();
    const options = computed(() => {
      if (!data.value) {
        return [];
      }
      const raw = toRaw(data.value);
      if (props.maxCount) {
        raw.records = raw?.records.map((item) => {
          if (props.value.length < 5) {
            item["disabled"] = false;
          } else {
            item["disabled"] = !props.value.includes(item.id);
          }
          return item;
        });
      }
      return raw?.records;
    });
    const titleValue = computed(() => {
      let tmpArr=options.value?.filter((i: any) => props.value.includes(i.id));
     return tmpArr.map((item) => item.name).join(",");
    });
    const onChange = (id) => {
      // console.log("🚀 ~ onChange ~ id:", id)
      emit("update:value", id);
      const types=options.value?.filter((i: any) =>id&&id.includes(i.id));
      let emitData = types.reduce((o:any, cur) => {
        if(cur['attribution']&&o.indexOf(cur['attribution'])===-1){
          o.push(cur['attribution']);
        }   
        return o;
      }, []);
      emit("update:typeAttributionList", emitData);
      const tmp = options.value?.filter((i: any) => i.id === id);
      if (tmp) {
        emit("change", tmp[0]);
      }
    };

    const onClear = () => {
      emit("update:value", "");
    };

     watch(()=>props.typeAttribution, (newVal, oldVal) => {
      run({attributionList:props.typeAttribution});
      console.log("🚀 ~ props.typeAttribution:", props.typeAttribution)
    }, { immediate: true });
   
    return {
      data,
      options,
      loading,
      onChange,
      onClear,
      titleValue
    };
  },
});
</script>
